import { render } from "./CertificationDetail.vue?vue&type=template&id=10059aac"
import script from "./CertificationDetail.vue?vue&type=script&lang=js"
export * from "./CertificationDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__